import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { CalendarRequest } from '../models/calendarRequest';

@Injectable({
  providedIn: 'root',
})
export class CalendarRequestService {
  public updateRequestNumberSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public updateRequestNumber$ = this.updateRequestNumberSubject.asObservable();

  constructor(private httpClient: HttpClient) {}

  updateUpdateRequestNumberSubject(reset: boolean, res: number): void {
    this.updateRequestNumberSubject.next(reset ? res : this.updateRequestNumberSubject.value + res);
  }

  isPeriodeContainCR(periode: any[], profileId: string): Observable<any> {
    return this.httpClient.get<CalendarRequest>(
      `${urlEndPoints.calendarRequest}/checkIfRequestAllowed?profileId=${profileId}&fromDate=${periode[0].substring(0, 10)}&toDate=${periode[1].substring(0, 10)}`
    );
  }

  deleteCR(request: any) {
    return this.httpClient.delete<CalendarRequest>(`${urlEndPoints.calendarRequest}/${request._id}`, request);
  }

  updateRequest(request: any): Observable<any> {
    return this.httpClient.put<CalendarRequest>(`${urlEndPoints.calendarRequest}`, request);
  }

  getActiveRequestsCounter(position: string, seniority?: string, detailedCounters: boolean = false): Observable<any> {
    return this.httpClient.get<any>(
      `${urlEndPoints.calendarRequest}/activeRequestsCounter?position=${position}` +
        (seniority ? `&seniority=${seniority}` : '') +
        `&detailedCounters=${detailedCounters}`
    );
  }

  getPaginateActiveRequestsFromTo(
    position: string,
    residency: string,
    seniority: string,
    fromDate: string,
    toDate: string,
    isNight: boolean,
    page?: number,
    limit?: number,
    isPaginate: boolean = true,
    searchValue: string = '',
    sortField: string = '',
    sortDirection: number = 1
  ): Observable<any> {
    return this.httpClient.get<CalendarRequest[]>(
      `${urlEndPoints.calendarRequest}/activeRequests?position=` +
        position +
        '&residency=' +
        residency +
        '&seniority=' +
        seniority +
        '&page=' +
        (page ? page : 1) +
        '&limit=' +
        limit +
        '&isPaginate=' +
        isPaginate +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        (searchValue ? '&searchValue=' + searchValue : '') +
        '&isNight=' +
        isNight +
        (sortField ? '&sortField=' + sortField : '') +
        (sortDirection ? '&sortDirection=' + sortDirection : '')
    );
  }

  countActiveRequests(position: string, startDate?: string, endDate?: string): Observable<any> {
    const query = '&fromDate=' + startDate + '&toDate=' + endDate;
    return this.httpClient.get<any>(`${urlEndPoints.calendarRequest}/countActiveRequests?position=${position}` + query);
  }

  getPaginateRequestsHistoryFromTo(
    position: string,
    residency: string,
    seniority: string,
    fromDate: string,
    toDate: string,
    isNight: boolean,
    page?: number,
    limit?: number,
    isPaginate: boolean = true,
    searchValue: string = '',
    sortField: string = '',
    sortDirection: number = 1
  ): Observable<any> {
    return this.httpClient.get<CalendarRequest[]>(
      `${urlEndPoints.calendarRequest}/activeRequests` +
        '?position=' +
        position +
        '&residency=' +
        residency +
        '&seniority=' +
        seniority +
        '&page=' +
        (page ? page : 1) +
        '&limit=' +
        limit +
        '&isPaginate=' +
        isPaginate +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&allHistory=true' +
        (searchValue ? '&searchValue=' + searchValue : '') +
        '&isNight=' +
        isNight +
        (sortField ? '&sortField=' + sortField : '') +
        (sortDirection ? '&sortDirection=' + sortDirection : '')
    );
  }

  getRequestsHistory(profileId: string, page?: number, limit?: number, showOnHold: boolean = false): Observable<any> {
    return this.httpClient.get<any>(
      `${urlEndPoints.calendarRequest}/history?profile=${profileId ? profileId : ''}` +
        '&page=' +
        (page ? page : 1) +
        '&limit=' +
        limit +
        '&showOnHold=' +
        showOnHold
    );
  }

  createCalendarRequest(
    calendarRequest: CalendarRequest,
    isExtra: boolean,
    createDirectCalendar: boolean
  ): Observable<CalendarRequest> {
    return this.httpClient.post<CalendarRequest>(urlEndPoints.calendarRequest, {
      request: calendarRequest,
      isExtra,
      createDirectCalendar,
    });
  }

  updateManyRequests(data: any): Observable<any> {
    return this.httpClient.put<CalendarRequest>(`${urlEndPoints.calendarRequest}/many`, data);
  }

  clear() {
    this.updateRequestNumberSubject.complete();
    this.updateRequestNumberSubject = new BehaviorSubject<number>(0);
  }
}
